
const Items =  [
  {
    'kodePenjualan': 'E14160071',
    'status': "Sedang dalam perjalanan",
    'pelanggan': 'CV Rimba Lestari',
    'penyediaJasaPengiriman': 'CV Mitra Sejahtera',
    'tanggalBerlaku': '21-03-2019',
    'pengirim': 'CV Mitra Sejahtera',
    'penjemputan': 'Jalan Cengal 105, Leuwiliang, Bogor, Jabar 16690',
    'penerima': 'PT Vera Sylva Kencana',

    'alamat': {
      'street': 'Jalan Cempaka 45, Ciamis, Jabar 16675',
    },
  },
  {
    'kodePenjualan': 'G84150073',
    'status': "Tersampaikan",
    'pelanggan': 'CV Tani Prima',
    'penyediaJasaPengiriman': 'PT Kayu Kencana Wangi',
    'tanggalBerlaku': '4-12-2018',
    'pengirim': 'PT Kayu Kencana Wangi',
    'penjemputan': 'Jalan Sudirman 45, Cianjur, Jabar 145278',
    'penerima': 'PT Laju Pasar Rimba',

    'alamat': {
      'street': 'Jalan Cempaka 45, Ciamis, Jabar 16675',
    },
  },
  {
    'kodePenjualan': 'A24260056',
    'status': "Belum konfirmasi",
    'pelanggan': 'PT Agro Wiseso',
    'penyediaJasaPengiriman': 'PT Laju Hutan Jaya',
    'tanggalBerlaku': '24-05-2018',
    'pengirim': 'PT Laju Hutan Jaya',
    'penjemputan': 'Jalan Kayuringin 62, Kuningan, Jabar 765423',
    'penerima': 'PT Jagawana Jaya',

    'alamat': {
      'street': 'Jalan Cempaka 45, Ciamis, Jabar 16675',
    },
  },
  {
    'kodePenjualan': 'F24150004',
    'status': "Konfirmasi",
    'pelanggan': 'CV Sukasari',
    'penyediaJasaPengiriman': 'CV Rindang Tretep',
    'tanggalBerlaku': '12-09-2018',
    'pengirim': 'CV Rindang Tretep',
    'penjemputan': 'Jalan Sentosa 76, Malang, Jatim, 765234',
    'penerima': 'CV Sultan Muda',

    'alamat': {
      'street': 'Jalan Cempaka 45, Ciamis, Jabar 16675',
    },
  },
  {
    'kodePenjualan': 'H14160065',
    'status': "Sedang dalam perjalanan",
    'pelanggan': 'PT Sukawening Asih',
    'penyediaJasaPengiriman': 'PT Tani Transport',
    'tanggalBerlaku': '15-03-2019',
    'pengirim': 'PT Tani Transport',
    'penjemputan': 'Jalan Raya Sukabumi 53, Sukabumi, Jabar 127651',
    'penerima': 'Unit Industri Kopi Kapal Api',

    'alamat': {
      'street': 'Jalan Cempaka 45, Ciamis, Jabar 16675',
    },
  },
  {
    'kodePenjualan': 'G64150076',
    'status': "Tersampaikan",
    'pelanggan': 'CV Mitra Sejahtera',
    'penyediaJasaPengiriman': 'PT Kayu Kencana Wangi',
    'tanggalBerlaku': '6-11-2018',
    'pengirim': 'PT Kayu Kencana Wangi',
    'penjemputan': 'Jalan Alternatif Ponorogo 34, Ponorogo, Jatim 765324',
    'penerima': 'Unit Gergaji Kayu Berkah Leuwiliang',

    'alamat': {
      'street': 'Jalan Cempaka 45, Ciamis, Jabar 16675',
    },
  },
  {
    'kodePenjualan': 'D24170034',
    'status': "Ditunda",
    'pelanggan': 'CV Indah Tani Lestari',
    'penyediaJasaPengiriman': 'PT Lintas Berkah',
    'tanggalBerlaku': '18-01-2019',
    'pengirim': 'PT Lintas Berkah',
    'penjemputan': 'Jalan Cempaka 45, Ciamis, Jabar 16675',
    'penerima': 'PT Agro Wiseso',

    'alamat': {
      'street': 'Jalan Cempaka 45, Ciamis, Jabar 16675',
    },
  },
];

const getPesananPengirimanById = (kodePenjualan) => {
  return (kodePenjualan === undefined) ? Items[0] : Items.find(x => x.kodePenjualan === kodePenjualan);
};

const getPesananPengiriman = (limit) => {
  return (limit) ? Items.slice(0, limit) : Items;
};

export {
  Items,
  getPesananPengiriman,
  getPesananPengirimanById
};